export enum TABS {
  CHAT = 0,
  NETWORKING_RECOMMENDATIONS = 1,
  PARTICIPANTS = 2,
  QA = 3,
  CC = 4,
  NONE = 5, // non interactive tab used to reset emoji reaction container height
  POLLS = 6,
}
